import { PermissionKey } from "../../components/Access/helper/permission/enum/PermissionKey";
import { PermissionV2 } from "../../components/Access/helper/permission/enum/PermissionV2";

export const useDummyAccess = false;

export const dummyAccess = {
    type: "user",
    permissions: {
        [PermissionKey.cp_flow_setting]: PermissionV2.delete,
        [PermissionKey.flow]: PermissionV2.read,

        // [PermissionKey.contact]: PermissionV2.create,
        [PermissionKey.contact_customer]: PermissionV2.create,
        [PermissionKey.contact_supplier]: PermissionV2.update,
        [PermissionKey.contact_employee]: PermissionV2.delete,

        // // Dashboard
        // [PermissionKey.dashboard]: PermissionV2.update,

        // // Sales
        // [PermissionKey.sale]: PermissionV2.update,
        // [PermissionKey.sale_quote]: PermissionV2.update,
        // [PermissionKey.sale_order]: PermissionV2.update,
        // [PermissionKey.sale_delivery_order]: PermissionV2.update,
        // [PermissionKey.sale_invoice]: PermissionV2.update,
        // [PermissionKey.sale_credit_note]: PermissionV2.update,
        // [PermissionKey.sale_payment]: PermissionV2.update,
        // [PermissionKey.sale_refund]: PermissionV2.update,

        // // Purchases
        // [PermissionKey.purchase]: PermissionV2.update,
        // [PermissionKey.purchase_order]: PermissionV2.update,
        // [PermissionKey.purchase_goods_received_note]: PermissionV2.update,
        // [PermissionKey.purchase_bill]: PermissionV2.update,
        // [PermissionKey.purchase_credit_note]: PermissionV2.update,
        // [PermissionKey.purchase_payment]: PermissionV2.update,
        // [PermissionKey.purchase_refund]: PermissionV2.update,

        // // Digital Shoebox
        // [PermissionKey.shoebox]: PermissionV2.update,

        // // Bank
        // [PermissionKey.bank]: PermissionV2.update,
        // [PermissionKey.bank_income]: PermissionV2.update,
        // [PermissionKey.bank_expense]: PermissionV2.update,
        // [PermissionKey.bank_transfer]: PermissionV2.update,
        // [PermissionKey.bank_account]: PermissionV2.update,

        // // Contact
        // [PermissionKey.contact]: PermissionV2.update,

        // // Product
        // [PermissionKey.product]: PermissionV2.update,
        // [PermissionKey.product_item]: PermissionV2.update,
        // [PermissionKey.product_group]: PermissionV2.update,
        // [PermissionKey.product_bundle]: PermissionV2.update,

        // // Stock
        // [PermissionKey.stock]: PermissionV2.update,
        // [PermissionKey.stock_adjustment]: PermissionV2.update,
        // [PermissionKey.stock_transfer]: PermissionV2.update,
        // [PermissionKey.stock_value]: PermissionV2.update,

        // // Reports
        // [PermissionKey.report]: PermissionV2.update,
        // [PermissionKey.report_balance_sheet]: PermissionV2.update,
        // [PermissionKey.report_profit_loss]: PermissionV2.update,
        // [PermissionKey.report_cash_flow]: PermissionV2.update,
        // [PermissionKey.report_financial_summary]: PermissionV2.update,

        // [PermissionKey.report_aged_receivable]: PermissionV2.update,
        // [PermissionKey.report_aged_payable]: PermissionV2.update,

        // [PermissionKey.report_invoice_summary]: PermissionV2.update,
        // [PermissionKey.report_sale_credit_note_summary]: PermissionV2.update,
        // [PermissionKey.report_sale_payment_summary]: PermissionV2.update,
        // [PermissionKey.report_sale_quote_by_customer]: PermissionV2.update,
        // [PermissionKey.report_sale_order_by_customer]: PermissionV2.update,
        // [PermissionKey.report_sale_by_customer]: PermissionV2.update,
        // [PermissionKey.report_sale_by_tag]: PermissionV2.update,

        // [PermissionKey.report_bill_summary]: PermissionV2.update,
        // [PermissionKey.report_purchase_credit_note_summary]: PermissionV2.update,
        // [PermissionKey.report_purchase_payment_summary]: PermissionV2.update,
        // [PermissionKey.report_purchase_order_by_supplier]: PermissionV2.update,

        // [PermissionKey.report_product_sale]: PermissionV2.update,
        // [PermissionKey.report_product_purchase]: PermissionV2.update,
        // [PermissionKey.report_item_sales_collection]: PermissionV2.update,

        // [PermissionKey.report_inventory]: PermissionV2.update,
        // [PermissionKey.report_profit_summary]: PermissionV2.update,

        // [PermissionKey.report_asset]: PermissionV2.update,

        // [PermissionKey.report_general_ledger]: PermissionV2.update,
        // [PermissionKey.report_debtor_ledger]: PermissionV2.update,
        // [PermissionKey.report_creditor_ledger]: PermissionV2.update,

        // [PermissionKey.report_sst]: PermissionV2.update,

        // [PermissionKey.report_trial_balance]: PermissionV2.update,
        // [PermissionKey.report_bank_reconciliation]: PermissionV2.update,
        // [PermissionKey.report_transaction_list]: PermissionV2.update,
        // [PermissionKey.report_exchange_gain_loss]: PermissionV2.update,
        // [PermissionKey.report_audit_trail]: PermissionV2.update,
        // [PermissionKey.report_payment_voucher_summary]: PermissionV2.update,
        // [PermissionKey.report_official_receipt_summary]: PermissionV2.update,
        // [PermissionKey.report_exchange_rates]: PermissionV2.update,
        // [PermissionKey.report_journal_entry_detail]: PermissionV2.update,
        // [PermissionKey.report_double_entry_detail]: PermissionV2.update,
        // [PermissionKey.report_chart_of_accounts]: PermissionV2.update,

        // [PermissionKey.reports_all]: PermissionV2.update,

        // // Accounting
        // [PermissionKey.accounting]: PermissionV2.update,
        // [PermissionKey.accounting_journal_entry]: PermissionV2.update,
        // [PermissionKey.accounting_contra]: PermissionV2.update,
        // [PermissionKey.accounting_fixed_asset]: PermissionV2.update,
        // [PermissionKey.accounting_deemed_payment]: PermissionV2.update,
        // [PermissionKey.accounting_chart_of_account]: PermissionV2.update,

        // [PermissionKey.flow]: PermissionV2.update,

        // Control Panel
        // [PermissionKey.control_panel]: PermissionV2.update,
        // [PermissionKey.cp_instruction]: PermissionV2.update,
        // [PermissionKey.cp_payment_term]: PermissionV2.update,
        [PermissionKey.cp_payment_method]: PermissionV2.read,
        // [PermissionKey.cp_form_design]: PermissionV2.update,
        // [PermissionKey.cp_price_level]: PermissionV2.update,
        // [PermissionKey.cp_currency]: PermissionV2.update,
        // [PermissionKey.cp_asset_type]: PermissionV2.update,
        // [PermissionKey.cp_location]: PermissionV2.update,
        // [PermissionKey.cp_number_format]: PermissionV2.update,
        // [PermissionKey.cp_custom_field]: PermissionV2.update,
        // [PermissionKey.cp_tag]: PermissionV2.update,
        // [PermissionKey.cp_company_profile]: PermissionV2.update,
        // [PermissionKey.cp_company_setting]: PermissionV2.update,
        // [PermissionKey.cp_flow_setting]: PermissionV2.update,
        // [PermissionKey.cp_shoebox_setting]: PermissionV2.update,
        // [PermissionKey.cp_integration]: PermissionV2.update,
        // [PermissionKey.cp_backup_data]: PermissionV2.update,

        // // Bukku Store Settings
        // [PermissionKey.store]: PermissionV2.update,

        // // Financing Portal
        // [PermissionKey.financing]: PermissionV2.update,

        // [PermissionKey.manage_users]: PermissionV2.update,
        // [PermissionKey.manage_billing]: PermissionV2.update,
        // [PermissionKey.partners]: PermissionV2.update,
    },
    manage_users: true,
    manage_billing: true,
    lock_period_bypass: false,
    partner_portal_access: false,
};
